import { SessionStatus } from '@heidi/schema/ml-scribe';
import { defineMessages } from 'react-intl';

export const filterLabelMessages = defineMessages({
  date: {
    defaultMessage: 'Date',
    id: 'KUxIxjKE6y',
    description: 'Session list filter dropdown — date sub-menu label',
  },
  patientProfile: {
    defaultMessage: 'Patient profile',
    id: 'BHORVjbabP',
    description: 'Session list filter dropdown — patient profile sub-menu label',
  },
  status: {
    defaultMessage: 'Status',
    id: '4egkfCdjMd',
    description: 'Session list filter dropdown — status sub-menu label',
  },
  clinician: {
    defaultMessage: 'Clinician',
    id: 'u9eRz1HNDw',
    description: 'Session list filter dropdown — clinician sub-menu label',
  },
  searchClinicians: {
    defaultMessage: 'Search clinicians',
    id: 'QtN985811s',
    description: 'Placeholder for the clinician search input',
  },
  noCliniciansFound: {
    defaultMessage: 'No clinicians found',
    id: 'OxNESEZAS0',
    description: 'Empty-state message when no clinicians match the search',
  },
  clearFilters: {
    defaultMessage: 'Clear filters',
    id: 'iLu1y3j0gG',
    description: 'Session list filter — clear all active filters button',
  },
});

export const statusNameMessages: Record<
  SessionStatus,
  { defaultMessage: string; id: string; description: string }
> = defineMessages({
  [SessionStatus.EMPTY]: {
    defaultMessage: 'No status',
    id: 'HzKG2iTJ3q',
    description: 'Session status name — no status',
  },
  [SessionStatus.DRAFT]: {
    defaultMessage: 'Draft',
    id: 'O8FDZqQ97A',
    description: 'Session status name — draft',
  },
  [SessionStatus.FOR_ACTION]: {
    defaultMessage: 'For action',
    id: 'SBxJekjlnS',
    description: 'Session status name — for action',
  },
  [SessionStatus.REVIEWED]: {
    defaultMessage: 'Reviewed',
    id: 'VMJPgaoTtm',
    description: 'Session status name — reviewed',
  },
  [SessionStatus.APPROVED]: {
    defaultMessage: 'Approved',
    id: 'vmNMRkTcm6',
    description: 'Session status name — approved',
  },
  [SessionStatus.SENT]: {
    defaultMessage: 'Sent',
    id: 'YZTmI3kG9R',
    description: 'Session status name — sent',
  },
});
